import { render, staticRenderFns } from "./MarketplaceContracts.vue?vue&type=template&id=ed301030&scoped=true&"
import script from "./MarketplaceContracts.vue?vue&type=script&lang=js&"
export * from "./MarketplaceContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed301030",
  null
  
)

export default component.exports